module.exports = __webpack_public_path__ + "static/media/extend.ae6ff1ac.png";